var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 395.17 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef7836;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.8,79.72A3.58,3.58,0,0,1,135.14,76V41.92a3.54,3.54,0,0,1,3.66-3.72h16.86c7.86,0,12.12,5.34,12.12,11.46a9.51,9.51,0,0,1-3.3,7.56,10.06,10.06,0,0,1,6.84,10c0,6.9-4.68,12.54-13.68,12.54Zm16.86-34.2H143v8.94h12.66c2.58,0,4.2-1.62,4.2-4.8A4.19,4.19,0,0,0,155.66,45.52ZM143,72.4h14.64c7,0,7-10.62,0-10.62H143Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.52,80.32c-11.1.48-22.62-6.9-22.62-21.6s11.52-22,22.62-22c10.5.54,21.48,7.8,21.48,22S222,80.32,211.52,80.32Zm-.66-35.82c-6.72,0-14,4.74-14,14.22s7.32,14.22,14,14.22c6.9,0,14.28-4.8,14.28-14.22S217.76,44.5,210.86,44.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.84,53.38v22.2a4.14,4.14,0,0,1-4.32,4.14c-1.92,0-3.6-1.5-3.6-4.14V41.8a4,4,0,0,1,3.6-4.14c1.74,0,2.76,1,3.78,2.16l11.2,17.82,11.68-18.48A3.89,3.89,0,0,1,291,41.8V95.58c0,2.64-1.68,4.14-3.6,4.14-2.16,0-3.84-1.5-3.84-4.14V53.38l-8,12.6c-2.16,2.64-4.86,2.64-6.84,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313,79.72A4.23,4.23,0,0,1,311.06,74L328.28,40.3a4.06,4.06,0,0,1,7.44,0L352.64,74c2.46,4.68-4.8,8.4-7,3.72L343,72.4H320.9l-2.58,5.28C317.36,79.72,315.14,80.14,313,79.72Zm25.8-15.24L332,49.66l-7.38,14.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.85,117c0-11.58,7.26-21.54,21.06-21.54,5.22,0,9.36,1.56,13.74,5.34a3.89,3.89,0,1,1-5.34,5.64c-2.46-2.58-5-3.3-8.4-3.3-9.24,0-13.68,6.54-13.68,13.86s4.38,14.28,13.68,14.28a14,14,0,0,0,9.36-3.84,4,4,0,0,1,5.52.72,4.14,4.14,0,0,1-.66,5.64c-4.2,3.9-9.24,4.68-14.22,4.68C141.39,138.51,134.85,128.61,134.85,117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212,138c-11.1.48-22.62-6.9-22.62-21.59s11.52-22,22.62-22c10.5.54,21.48,7.8,21.48,22S222.5,138,212,138Zm-.66-35.81c-6.72,0-14,4.74-14,14.22s7.32,14.21,14,14.21c6.9,0,14.28-4.8,14.28-14.21S218.24,102.16,211.34,102.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.16,109.82c0-5.34,7.86-5.76,7.86,0v11.71c0,22.44-37.18,22.44-37.18,0V89.82c0-5.4,7.86-5.64,7.86,0v31.71c0,11.82,21.46,12.54,21.46,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.24,134.47c0,5.22-8,5.4-8,.12V100.52a3.59,3.59,0,0,1,3.6-3.66h16c15.24,0,18.36,20.39,5.64,25.49l8,9.72c3.12,4.62-3.12,9.06-6.72,4.5l-9.06-13h-9.42Zm0-17.76h11.58c7.8,0,8.28-12.59,0-12.59H317.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.1,104.36H362.6c-5.22,0-5.22-7.68,0-7.68H391a3.84,3.84,0,1,1,0,7.68H381v30.29c0,5.22-7.92,5.34-7.92,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8,
    y: 56,
    width: 8,
    height: 56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107,84A27.93,27.93,0,0,0,83,56.29v55.42A27.93,27.93,0,0,0,107,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51,84a27.93,27.93,0,0,0,24,27.71V56.29A27.93,27.93,0,0,0,51,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112,8H8V48H20a4,4,0,0,1,4,4v64a4,4,0,0,1-4,4H8v40H112"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75,119.77a36,36,0,0,1,0-71.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391,160H83V119.77a36,36,0,0,0,0-71.54V8H349a4,4,0,1,0,0-8H4A4,4,0,0,0,0,4V164a4,4,0,0,0,4,4H391A4,4,0,1,0,391,160ZM83,56.29a28,28,0,0,1,0,55.42ZM8,56h8v56H8Zm67,55.71a28,28,0,0,1,0-55.42Zm0-63.48a36,36,0,0,0,0,71.54V160H8V120H20a4,4,0,0,0,4-4V52a4,4,0,0,0-4-4H8V8H75Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.be0c63727585313ef517dffafc2c5081.svg";
export { ForwardRef as ReactComponent };